import { fetchWithRetry, isServer } from '@tunein/web-utils';
import tuneInRequest from '../tuneInRequest';
export default function analyticsService(config, apiContext, applyReauth) {
    const analyticsEndpoint = `${config.domains.local}/analytics`;
    const loopback = `${config.domains.loopback}${analyticsEndpoint}`;
    const loopbackOrProxyEndpoint = isServer() ? loopback : analyticsEndpoint;
    const roktEventsEndpoint = 'https://api.rokt.com/v1/events';
    const roktAuthenticationEndpoint = 'https://api.rokt.com/auth/oauth2/token';
    function reportRoktConversion(roktId) {
        return tuneInRequest({
            method: 'post',
            url: `${loopbackOrProxyEndpoint}/roktConversion/`,
            data: { roktId },
            disableRetry: true,
        }, apiContext);
    }
    function authenticateWithRokt() {
        return fetchWithRetry(roktAuthenticationEndpoint, {
            method: 'POST',
            body: new URLSearchParams({
                grant_type: 'client_credentials',
            }).toString(),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Basic ${config.rokt.apiKey}`,
            },
            agent: apiContext.apiHttpsAgent,
        });
    }
    async function reportConversionToRokt(eventId, emailHash, roktId) {
        const roktAuth = await authenticateWithRokt();
        const accessToken = roktAuth.access_token;
        return fetchWithRetry(roktEventsEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Charset: 'utf-8',
                Authorization: `Bearer ${accessToken}`,
                'Rokt-Version': config.rokt.apiVersion,
                'Idempotency-Key': eventId,
            },
            agent: apiContext.apiHttpsAgent,
            body: JSON.stringify({
                accountId: config.rokt.accountId,
                events: [
                    {
                        eventType: 'conversion',
                        clientEventId: eventId,
                        eventTime: new Date().toISOString(),
                        objectData: [
                            { name: 'emailsha256', value: emailHash },
                            ...(roktId
                                ? [{ name: 'passbackconversiontrackingid', value: roktId }]
                                : []),
                        ],
                    },
                ],
            }),
        });
    }
    return {
        reportRoktConversion: applyReauth(reportRoktConversion),
        reportConversionToRokt,
    };
}
